import logoACRA from "@assets/events-awards/sca/logo-acra.jpg";
import logoISCA from "@assets/events-awards/sca/logo-isca.png";
import logoSC from "@assets/events-awards/sca/logo-sc.svg";
import logoSGX from "@assets/events-awards/sca/logo-sgx.png";
import logoSID from "@assets/events-awards/sca/logo-sid.jpg";
import logoBT from "@assets/logo-masthead.svg";
import Container from "@components/Container/Container";

/**
 * Component to render Organiser Details of SCA on homepage
 */
const SCAOrganiserDetails = (): React.ReactElement => {
  return (
    <Container>
      <div className="flex flex-col justify-center px-3 pb-15 pt-8 font-public-sans md:px-6 lg:flex-row lg:items-start lg:px-0 lg:pb-20 lg:pl-7 lg:pt-12">
        <div className="flex flex-col items-center lg:w-1/3">
          <p>Co-organised By</p>

          <img
            src={logoBT}
            width={214}
            height={20}
            alt="The Business Times logo"
            className="my-6"
          />

          <img
            src={logoISCA}
            width={170}
            height={37}
            alt="The Business Times logo"
            className="my-6"
          />

          <img
            src={logoSID}
            width={170}
            height={79}
            alt="The Business Times logo"
            className="my-6"
          />
        </div>

        <div className="flex flex-col items-center lg:w-1/3">
          <p>Presenting Sponsor</p>

          <img
            src={logoSC}
            width={200}
            height={105}
            alt="The Business Times logo"
          />
        </div>

        <div className="flex flex-col items-center lg:w-1/3">
          <p>Supported By</p>

          <img
            src={logoACRA}
            width={120}
            height={55}
            alt="The Business Times logo"
            className="my-6"
          />

          <img
            src={logoSGX}
            width={160}
            height={30}
            alt="The Business Times logo"
            className="my-6"
          />
        </div>
      </div>
    </Container>
  );
};

export default SCAOrganiserDetails;
